import { Component } from '@angular/core';

@Component({
  selector: 'portal-step-3-svg',
  standalone: true,
  templateUrl: './step-3.component.svg',
  styleUrl: './step-3.component.scss',
})
export class Step3SvgComponent {}
